import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useStore } from "../context/StoreContext";
import { Reveal } from "../components/Reveal";
import NotFound from "./NotFound";

export default function Policy() {
  const { slug } = useParams();
  const { L } = useStore();
  const pol = L.policies[slug];

  if (!pol) return <NotFound />;

  return (
    <div className="pt-32 pb-24 star-lattice min-h-screen" data-testid="policy-page">
      <div className="max-w-3xl mx-auto px-5 lg:px-8">
        <Reveal>
          <Link to="/shop" data-testid="policy-back-link" className="inline-flex items-center gap-2 text-[0.65rem] tracking-[0.25em] uppercase text-ivory/60 hover:text-gold transition-colors">
            <ArrowLeft className="w-4 h-4" /> ARIJ MISK
          </Link>
          <h1 className="font-display text-4xl sm:text-5xl text-ivory mt-6" data-testid="policy-title">{pol.title}</h1>
        </Reveal>
        <div className="mt-12 space-y-8">
          {pol.sections.map((s, i) => (
            <Reveal key={i} delay={0.05 * i}>
              <section className="border border-gold/20 rounded-2xl p-7 bg-onyx/50" data-testid={"policy-section-" + i}>
                <h2 className="font-display text-xl text-gold">{s.h}</h2>
                <div className="mt-3 space-y-2.5">
                  {s.ps.map((p, j) => (
                    <p key={j} className="text-sm text-ivory/80 leading-relaxed">{p}</p>
                  ))}
                </div>
              </section>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
